// Single source for the JS side of the mobile breakpoint. The CSS drawer
// rules (Sidebar.css, AppHeader.css, index.css) use the same 767px value in
// their @media queries, which cannot read JS constants.
export const MOBILE_MAX_WIDTH_PX = 767;
export const MOBILE_QUERY = `(max-width: ${MOBILE_MAX_WIDTH_PX}px)`;

export function isMobileViewport() {
  return typeof window.matchMedia === "function" && window.matchMedia(MOBILE_QUERY).matches;
}
